import { EServerPath } from '~/models/api'

const queryKeys = {
  templates: (filters: object = {}) => [EServerPath.templates, filters],
}

export default queryKeys
